export const formatTagList = (tags) => {
    return tags
        .map((node) => {
            const name = node.tag?.document?.data?.name;
            const slug = name?.toLowerCase?.()?.split?.(' ')?.join?.('-');

            // if only we have the name and the slug of the tag, return it
            return name && slug && { name, slug };
        })
        .filter(Boolean);
};
